export enum AUTORIZATION {
    NOTIFICATION = 'Módulo IMs',
    SAFETY = 'Módulo de segurança',
    COMMUNICATIONS = 'Módulo Comunicados',
    COMMUNICATIONS_APP = 'Comunicados Corporativos',
    CENCO_GEO = 'CencoGEO',
    CONFIGURATION = 'Configurações',
    PRODUTOS = 'Produtos',
    STORE = 'Loja',
    AVALIACAO_LOJA = 'Avaliação de Loja',
    GESTAO_PATIO = 'Gestão de Pátio',
    MODULO_AVALIACAO_LOJA = 'Módulo Avaliação de Loja',
    MANUTENCAO_HORARIO = 'Manutenção Horário de Lojas',
    AVALIACAO_LOJA_GESTOR = 'Avaliação de Loja (Gestor)',
    TASKS = "Criação de tarefas",
    STORE_MANAGER = "Manutenção Lojas"
}
